<template>
	<div class="job-teacher-page">
		<!-- 页面标题 -->
		<div class="page-header">
			<div class="title-line">
				<span class="line"></span>
				<span class="title">备课组长</span>
			</div>
		</div>

		<!-- 学段切换 tabs -->
		<div class="grade-tabs">
			<span 
				v-for="item in stageListFiltered" 
				:key="item.value" 
				class="grade-tab"
				:class="{ active: currentSection === item.value }" 
				@click="selectSection(item.value)"
			>
				{{ item.label }}
			</span>
		</div>

		<div style="max-width: 80%;">
			<el-table :data="gradeList" border style="width: 100%;" class="job-table">
				<!-- 第一列：年级 -->
				<el-table-column prop="gradeName" label="年级" align="center" />
			
				<!-- 各学科备课组长 -->
				<el-table-column 
					v-for="sub in subjectList.filter(v=>v.value!=0)" 
					:key="sub.value" 
					:label="sub.label" 
					align="center"
				>
					<template slot-scope="scope">
						<el-button type="text" class="teacher-btn" @click="openSetDialog(scope.row.grade, sub.value, 7)">
							{{ getTeacher(scope.row.grade, sub.value, 7) || '设置' }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 设置教师弹窗 -->
		<el-dialog title="设置备课组长" :visible.sync="dialogVisible" width="550px" :append-to-body="true" center
		  	:loading="dialogLoading">
			<el-select
				v-model="selectedTeacherId"
				placeholder="请选择教师"
				filterable
				remote
				:remote-method="searchTeacher"
				style="width: 100%; margin-bottom: 15px;"
				clearable
			>
				<el-option
					v-for="teacher in teacherList"
					:key="teacher.id"
					:label="teacher.name"
					:value="teacher.id"
				></el-option>
			</el-select>

			<div v-if="selectedTeacherId" style="padding: 10px; background: #f7f8fa; border-radius: 6px;">
				已选教师：<b>{{ getSelectedName() }}</b>
				<el-button type="success" size="mini" @click="saveTeacher" style="margin-left: 10px;">
					确认保存
				</el-button>
			</div>

			<div style="margin-top: 15px;">
				<div style="font-weight: bold; margin-bottom: 8px;">当前任职：</div>
				<el-tag
					v-for="item in currentAssignList"
					:key="item.id"
					type="primary"
					closable
					@close="deleteAssign(item.id)"
					style="margin-right: 8px; margin-bottom: 8px;"
				>
					{{ item.teacherName }}
				</el-tag>
				<div v-if="currentAssignList.length === 0" style="color: #999;">暂无任职</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { teacherSubject } from "@/js/standard.js";

export default {
	name: "JobTeacher",
	data() {
		return {
			schoolId: localStorage.getItem('orgId'),
			schoolInfo: {},
			// 学段配置 和校领导页面一致
			stageList: [
				{ label: '小学', value: 1 },
				{ label: '初中', value: 2 },
				{ label: '高中', value: 3 }
			],
			currentSection: null,

			gradeList: [],
			subjectList: [],
			teacherMap: {},

			dialogVisible: false,
			dialogGradeId: null,
			dialogSubjectId: null,
			

			teacherList: [],
			selectedTeacherId: null,
			currentAssignList: [],
			login:null,
			subjectLists:[],
		};
	},
	computed: {
		stageListFiltered() {
			if (!this.schoolInfo.stages) return []
			return this.stageList.filter(item => 
				this.schoolInfo.stages.includes(item.value.toString())
			)
		}
	},
	created() {
		this.forSubject();
		
		
	},
	methods: {
		loginOpen(text) {
		  this.login = this.$loading({
		    lock: true,
		    text: text,
		    zIndex: 100001,
		    spinner: 'el-icon-loading',
		    background: 'rgba(0, 0, 0, 0.7)'
		  });
		},
		noLogin(){
		  if(this.login){
		    this.login.close()
		    this.login = null;
		  }
		},
		async forSubject() {
			if(this.subjectLists.length==0){
				this.subjectLists =await teacherSubject();
				this.getSchoolInfo();
			}else{
				this.getSchoolInfo();
			}
			
		},

		// 获取学校信息 初始化学段
		getSchoolInfo() {
			this.loginOpen('任职信息加载中...')
			this.API.get(this.API.school.getSchoolId + this.schoolId).then(res => {
				if (res.data.code === 200) {
					this.schoolInfo = res.data.data;
					if (this.stageListFiltered.length > 0) {
						this.selectSection(this.stageListFiltered[0].value);
					}
				}
			})
		},

		// 切换学段 → 加载该学段下所有年级
		selectSection(sectionVal) {
			this.currentSection = sectionVal;
			this.subjectList=this.subjectLists?.filter(v=>v.stageCode==sectionVal)
			this.loadGradeBySection(sectionVal);
		},

		// 根据学段查年级
		loadGradeBySection(sectionVal) {
			this.API.get(this.API.school.getSchoolGrad, {
				schoolId: this.schoolId
			}).then(res => {
				var list = res.data.data || [];
				
				this.gradeList=list
				// 加载该学段下所有年级的备课组长任职
				this.$nextTick(()=>{
					this.loadAllAssignBySection(sectionVal);
				})
			})
		},

		// 加载当前学段所有年级任职
		loadAllAssignBySection(sectionId) {
			this.API.get(this.API.school.getSchoolUpdateId + "?schoolId=" + this.schoolId + "&sectionId=" + sectionId).then(res => {
				let list = res.data.data || [];
				this.teacherMap = {};
				list.forEach(item => {
					let key = `${item.gradeId}_${item.subjectId}_${item.roleType}`;
					if (this.teacherMap[key]) {
						if (!this.teacherMap[key].includes(item.teacherName)) {
							this.teacherMap[key] = `${this.teacherMap[key]}|${item.teacherName}`;
						}
					} else {
						this.teacherMap[key] = item.teacherName;
					}
				});
				this.noLogin()
			}).catch(()=>{
				this.noLogin()
			})
		},

		getTeacher(gradeId, subjectId, roleType) {
			let key = `${gradeId}_${subjectId}_${roleType}`;
			return this.teacherMap[key];
		},

		// 打开弹窗 传年级ID
		openSetDialog(gradeId, subjectId, roleType) {
			this.loginOpen('年级学科信息加载中...')
			this.dialogGradeId = gradeId;
			this.dialogSubjectId = subjectId;
			this.dialogRoleType = 7;
			this.selectedTeacherId = null;
			
			this.loadCurrentAssign();
		},

		// 加载当前年级+学科+角色任职
		loadCurrentAssign() {
			this.API.get(this.API.school.getSchoolUpdateId,{
				sectionId:this.currentSection,
				gradeId:this.dialogGradeId,
				schoolId:this.schoolId,
				subjectId:this.dialogSubjectId
			}).then(res => {
				let all = res.data.data;
				this.currentAssignList = all.filter(item =>
					item.subjectId == this.dialogSubjectId &&
					item.roleType == this.dialogRoleType
				);
				this.noLogin()
				this.dialogVisible = true;
			}).catch(()=>{
				this.noLogin()
			})
		},

		searchTeacher(key) {
			let name = key || ''
			this.loginOpen('教师列表查询中...')
			this.API.get(this.API.school.getSchoolSearch, {
				pageNum: 1,
				pageSize: 100,
				schoolId: this.schoolId,
				name: name
			}).then(res => {
				this.teacherList = res.data.data.records;
				this.noLogin()
			}).catch(()=>{
				this.noLogin()
			})
		},

		getSelectedName() {
			let t = this.teacherList.find(u => u.id == this.selectedTeacherId);
			return t ? t.name : "";
		},

		saveTeacher() {
			if (!this.selectedTeacherId) {
				return this.$message.warning("请选择教师");
			}
			this.loginOpen('任职设置中...')
			let params = {
				userId: this.selectedTeacherId,
				gradeId: this.dialogGradeId,
				subjectId: this.dialogSubjectId,
				
				roleType: 7,
				schoolId: this.schoolId,
				sectionId: this.currentSection
			};
			this.API.post(this.API.school.postAssignSave, params).then((res) => {
				if (res.data.code == 500) {
					this.$message.error(res.data.msg);
					this.selectedTeacherId = null;
				} else {
					this.$message.success("设置成功");
					this.loadAllAssignBySection(this.currentSection);
					// this.loadGradeBySection();
					this.selectedTeacherId = null;
				}
				this.noLogin()
			}).catch(()=>{
				this.noLogin()
			})
		},

		deleteAssign(id) {
			this.loginOpen('任职取消中...')
			this.API.deleted(this.API.school.deletedAssign + id).then(() => {
				this.$message.success("已取消任职");
				this.noLogin()
				this.loadAllAssignBySection(this.currentSection);
				this.loadCurrentAssign();
			}).catch(()=>{
				this.noLogin()
			})
		}
	}
};
</script>

<style scoped>
.job-teacher-page {
	width: calc(60vw);
	padding: 15px;
}

.page-header {
	margin-bottom: 20px;
}

.title-line {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}

.line {
	display: inline-block;
	width: 3px;
	height: 16px;
	background-color: #1e88e5;
	margin-right: 8px;
}

.title {
	font-size: 14px;
	font-weight: bold;
	color: #333;
}

.grade-tabs {
	margin-bottom: 15px;
}

.grade-tab {
	display: inline-block;
	padding: 0 8px;
	margin-right: 10px;
	font-size: 14px;
	cursor: pointer;
	color: #666;
}

.grade-tab.active {
	color: #1e88e5;
	font-weight: 500;
}

.job-table /deep/ th {
	background-color: #1e88e5;
	color: #fff;
}

/deep/ .el-button--text {
	color: #1e88e5;
}
.teacher-btn {
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>